import React from 'react';
import slColors from 'sl-colors';
import { GRID_COLORS } from 'components/HirerComponents/AnalyticsHub/TeamHiring/const';

const WORKING_STYLE_BUCKETS = {
  ONE: {
    FROM: 0,
    TO: 24,
  },
  TWO: {
    FROM: 25,
    TO: 34,
  },
  THREE: {
    FROM: 35,
    TO: 50,
  },
  FOUR: {
    FROM: 51,
    TO: 64,
  },
  FIVE: {
    FROM: 65,
    TO: 74,
  },
  SIX: {
    FROM: 75,
    TO: 100,
  },
};

export const cells = [
  {
    lowerLimit: WORKING_STYLE_BUCKETS.ONE.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.ONE.TO,
    style: {
      backgroundColor: GRID_COLORS.DARKER,
      border: `0.5px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-700 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Very
      </span>
    ),
  },
  {
    lowerLimit: WORKING_STYLE_BUCKETS.TWO.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.TWO.TO,
    style: {
      backgroundColor: GRID_COLORS.LIGHTER,
      border: `0.5px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-500 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Moderate
      </span>
    ),
  },
  {
    lowerLimit: WORKING_STYLE_BUCKETS.THREE.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.THREE.TO,
    style: {
      backgroundColor: GRID_COLORS.LIGHTER,
      border: `0.5px solid ${slColors.gray[300]}`,
      borderLeft: `1px solid ${slColors.gray[300]}`,
      borderRight: `1px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-500 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Slightly
      </span>
    ),
  },
  {
    lowerLimit: WORKING_STYLE_BUCKETS.FOUR.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.FOUR.TO,
    style: {
      backgroundColor: GRID_COLORS.LIGHTER,
      border: `0.5px solid ${slColors.gray[300]}`,
      borderLeft: `1px solid ${slColors.gray[300]}`,
      borderRight: `1px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-500 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Slightly
      </span>
    ),
  },
  {
    lowerLimit: WORKING_STYLE_BUCKETS.FIVE.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.FIVE.TO,
    style: {
      backgroundColor: GRID_COLORS.LIGHTER,
      border: `0.5px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-500 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Moderate
      </span>
    ),
  },
  {
    lowerLimit: WORKING_STYLE_BUCKETS.SIX.FROM,
    upperLimit: WORKING_STYLE_BUCKETS.SIX.TO,
    style: {
      backgroundColor: GRID_COLORS.DARKER,
      border: `0.5px solid ${slColors.gray[300]}`,
    },
    topLegend: (
      <span className="tw-text-xs tw-text-gray-700 tw-font-medium tw-leading-5 tw-block tw-mb-2">
        Very
      </span>
    ),
  },
];
